var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckMarkPasswordStrength = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkMarkPasswordStrength",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5770",
    "data-name": "Path 5770",
    d: "M19.7,13.041l-.762-.783a.164.164,0,0,0-.121-.052h0a.157.157,0,0,0-.121.052L13.42,17.576,11.5,15.655a.167.167,0,0,0-.242,0l-.77.77a.172.172,0,0,0,0,.247l2.423,2.423a.766.766,0,0,0,.506.247.8.8,0,0,0,.5-.238h0l5.785-5.815A.185.185,0,0,0,19.7,13.041Z",
    transform: "translate(-2.715 -3.397)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5771",
    "data-name": "Path 5771",
    d: "M12.375,4.587a7.785,7.785,0,1,1-5.508,2.28,7.737,7.737,0,0,1,5.508-2.28m0-1.212a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z",
    fill: "inherit"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckMarkPasswordStrength, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkMarkPasswordStrength.beefa838.svg";
export { ForwardRef as ReactComponent };